<template>
  <div class="enterprise-page">
    <div
      v-if="$can('create', 'waste')"
      class="btn-actions-content"
    >
      <b-button
        class="btn-grad d-inline-block align-items-center"
        @click="openModal({action: 'create'})"
      >
        <VSIcons
          name="AddSquare"
          width="22"
          height="22"
          class="pr-2 align-middle d-inline-block"
        />
        <span class="align-middle d-inline-block">Adicionar</span>
      </b-button>
      <b-button
        class="btn-grad d-inline-block align-items-center ml-1"
        @click="importWaste()"
      >
        <VSIcons
          name="AddSquare"
          width="22"
          height="22"
          class="pr-2 align-middle d-inline-block"
        />
        <span class="align-middle d-inline-block">Importar</span>
      </b-button>
    </div>
    <b-input-group class="input-group-merge round search-input-filter">
      <b-input-group-prepend
        is-text
      >
        <VSIcons
          name="Search"
          color="#7D8E9E"
          width="18"
          height="18"
        />
      </b-input-group-prepend>
      <b-form-input
        id="filter-input"
        v-model="filter"
        placeholder="Buscar..."
        type="search"
      />
    </b-input-group>
    <b-table
      id="enterprise-table"
      ref="enterpriseTable"
      class="details-table mt-4"
      :items="items"
      :fields="fields"
      hover
      responsive
      details-td-class="align-middle"
      :busy="apiInCall"
      :per-page="perPage"
      :current-page="currentPage"
      :filter="filter"
      :filter-included-fields="filterOn"
      empty-filtered-text="Não há resultados para sua pesquisa."
      empty-text="Não há registros para serem exibidos."
      show-empty
      @filtered="onFiltered"
    >
      <template #table-busy>
        <b-spinner variant="primary" />
      </template>
      <template
        v-if="$can('delete', 'waste')"
        #head(select)
      >
        <b-form-checkbox
          v-model="allSelected"
          :indeterminate="indeterminate"
          @change="toggleAll('system/waste/operation', 'WasteOperations')"
        />
      </template>
      <template
        v-if="$can('delete', 'waste')"
        #cell(select)="row"
      >
        <b-form-checkbox
          v-model="selected"
          :value="row.item"
          @change="setItensToDelete({ itens: selected, api: 'system/waste/operation', fetchTable: 'WasteOperations' })"
        />
      </template>
      <template #cell(inventory)="row">
        {{ row.item.inventory.name }}
      </template>
      <template #cell(receipt_data)="row">
        {{ row.item.receipt_data | formatLocalDate }}
      </template>
      <template #cell(consignee)="row">
        {{ row.item.consignee ? row.item.consignee.fantasy_name || row.item.consignee.full_name : '' }}
      </template>
      <template #cell(carrier_id)="row">
        {{ row.item.carrier ? row.item.carrier.fantasy_name || row.item.carrier.full_name : '' }}
      </template>
      <template #cell(data)="row">
        <div class="d-flex align-items-center justify-content-center">
          <span class="validade">{{ row.item.data }}</span>
          <div>
            <VSIcons
              name="calendar"
              height="18"
            />
          </div>
        </div>
      </template>
      <template #cell(cdf)="row">
        {{ row.item.cdf }}
      </template>
      <template #cell(actions)="row">
        <b-dropdown
          no-caret
          right
          variant="light"
          menu-class="dropdown-table-actions"
          toggle-class="button-dropdown-actions"
        >
          <template #button-content>
            <VSIcons
              name="Actions"
              width="5"
              height="22"
            />
          </template>
          <b-dropdown-item
            class="dropdown-table-item"
            @click="openModal({item: row.item, action: 'read'})"
          >
            <VSIcons
              name="Eye"
              width="20"
              height="20"
              color="#7D8E9E"
            />
            <span>
              Ver
            </span>
          </b-dropdown-item>
          <b-dropdown-divider v-if="$can('update', 'waste')" />
          <b-dropdown-item
            v-if="$can('update', 'waste')"
            class="dropdown-table-item"
            @click="uploadFile(row.item)"
          >
            <VSIcons
              name="PaperClip"
              width="20"
              height="20"
              color="#7D8E9E"
            />
            <span>
              Anexar
            </span>
          </b-dropdown-item>
          <b-dropdown-divider v-if="$can('update', 'waste')" />
          <b-dropdown-item
            v-if="$can('update', 'waste')"
            class="dropdown-table-item"
            @click="openModal({item: row.item, action: 'edit'})"
          >
            <VSIcons
              name="Edit"
              width="20"
              height="20"
              color="#7D8E9E"
            />
            <span>
              Editar
            </span>
          </b-dropdown-item>
          <b-dropdown-divider v-if="$can('delete', 'waste')" />
          <b-dropdown-item
            v-if="$can('delete', 'waste')"
            class="dropdown-table-item"
            @click="deleteItem(row.item)"
          >
            <VSIcons
              name="TrashSquare"
              width="21"
              height="21"
              color="#7D8E9E"
            />
            <span>
              Excluir
            </span>
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="enterprise-table"
    >
      <template #prev-text>
        <VSIcons name="ArrowLeft" />
      </template>
      <template #next-text>
        <VSIcons name="ArrowRight" />
      </template>
    </b-pagination>
    <VSModal
      ref="operationsModal"
      name="Operations"
      :properties="properties"
      width="1280"
      :open-modal-search-code="openModalSearchCode"
    />
    <VSModal
      width="570"
      :properties="itemToDelete"
      name="DeleteOneItem"
    />
    <VSModal
      name="UploadFile"
      :properties="properties"
    />
    <VSModal
      name="SearchCode"
      width="970"
      :send-waste-data="sendWasteData"
    />
  </div>
</template>

<script>
import {
  BInputGroup,
  BInputGroupPrepend,
  BFormInput, BTable,
  BButton,
  BFormCheckbox,
  BSpinner,
  BPagination,
  BDropdownItem,
  BDropdown,
  BDropdownDivider,
} from 'bootstrap-vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { formatLocalDate } from '@core/utils/filter'
import { tableConfig } from '@core/mixins/ui/forms'
import VSIcons from '@/assets/icons/VSIcons.vue'
import VSModal from '@/components/modals/VSModal.vue'

export default {
  components: {
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BTable,
    BButton,
    BFormCheckbox,
    BSpinner,
    BPagination,
    BDropdownItem,
    BDropdown,
    BDropdownDivider,
    VSIcons,
    VSModal,
  },
  filters: {
    formatLocalDate,
  },
  mixins: [
    tableConfig,
  ],
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      itemToDelete: { api: '/system/waste/operation', fetchTable: 'WasteOperations' },
      properties: { action: '', item: {} },
      providers: [],
      fields: [
        {
          label: '',
          key: 'select',
          tdClass: 'align-middle',
        },
        {
          label: 'Situação',
          key: 'status',
          sortable: true,
          tdClass: 'align-middle',
        },
        {
          label: 'Data do Recebimento',
          key: 'receipt_data',
          sortable: true,
          tdClass: 'align-middle',
        },
        {
          label: 'Resíduo',
          key: 'inventory',
          sortable: true,
          tdClass: 'align-middle',
        },
        {
          label: 'Transportador',
          key: 'carrier_id',
          sortable: true,
          tdClass: 'align-middle',
        },
        {
          label: 'Destinador',
          key: 'consignee',
          sortable: true,
          tdClass: 'align-middle',
        },
        {
          label: 'MTR',
          key: 'mtr_number',
          sortable: true,
          tdClass: 'align-middle',
        },
        {
          label: 'Peso Líquido/Quantidade',
          key: 'quantity',
          sortable: true,
          tdClass: 'align-middle',
        },
        {
          label: 'Unidade',
          key: 'unit',
          sortable: true,
          tdClass: 'align-middle',
        },
        {
          label: 'Classe',
          key: 'classification',
          sortable: true,
          tdClass: 'align-middle',
        },
        {
          label: 'Tecnologia',
          key: 'technology',
          sortable: true,
          tdClass: 'align-middle',
        },
        {
          label: 'CDF',
          key: 'cdf',
          tdClass: 'align-middle',
        },
        {
          label: '',
          key: 'actions',
          tdClass: 'align-middle p-0 pr-4',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({ apiInCall: 'app/getApiInCall' }),
  },
  created() {
    this.fetchProviders().then(res => { this.providers = res.data })
  },
  methods: {
    ...mapMutations({ setItensToDelete: 'app/SET_ITENS_DELETE' }),
    ...mapActions({ fetchProviders: 'provider/fetchProviders' }),
    openModal(item) {
      this.properties = item
      this.properties.module = this.module
      this.showModal('Operations')
    },
    importWaste() {
      this.$router.push(`/importacao/${this.$route.params.id}/residuos`)
    },
    uploadFile(row) {
      this.properties.action = 'create'
      this.properties.relations = [{ name: 'operation_id', id: row.id }]
      this.properties.relations.push({ name: 'waste_id', id: this.$route.params.id })
      this.showModal('UploadFile')
    },
    openModalSearchCode() {
      this.showModal('SearchCode')
    },
    sendWasteData(data) {
      this.hideModal('SearchCode')
      this.$refs.operationsModal.receiveWasteData(data)
    },
  },
}
</script>
